import React from 'react';
import { Box, IconButton, Toolbar } from '@material-ui/core';
import RotateLeftIcon from '@material-ui/icons/RotateLeft';
import { pickBy } from 'lodash/fp';
import { useHistory } from 'react-router-dom';
import { Filters, LIMIT, LoadMoreComponent, useFilter } from '../../../shared';
import { useDebounce } from '../../../../utils';
import { FixedBox, SecondaryToolbar } from '../../../../ui-kit';
import { GET_ORDERS } from '../../graphql';
import { getUrlParams } from '../../../../utils/helpers/urlParams';
import { DateFromTo, QueryOrdersArgs } from '../../../../generated/graphql';
import MoreFilters from './MoreFilters';

const initialState = {
    place: '',
    openedBy: '',
    name: '',
    date: { from: undefined, to: undefined },
    moreFilters: {
        multiple: false,
        single: false,
        onPlace: false,
        toGo: false,
        open: false,
        closed: false,
        canceled: false,
    },
};

const Orders = () => {
    const history = useHistory();
    const [openParam, cancelledParam] = getUrlParams({ searchString: history.location.search, params: ['open', 'cancelled'] });

    const { formData, handleChange, setFormData } = useFilter({
        ...initialState,
        moreFilters: {
            ...initialState.moreFilters,
            open: !!openParam,
            canceled: !!cancelledParam,
        }
    });

    const resetFilters = () => {
        setFormData(initialState);
        history.push({ search: '' });
    };
    const variables = useDebounce(formData);

    const { moreFilters, date, ...otherFilters } = variables;

    let finalDate: DateFromTo | undefined;

    if (date.from !== undefined && date.to !== undefined) {
        finalDate = {
            ...date as unknown as DateFromTo
        };
    }
    const finalFilters = {
        moreFilters,
        date: finalDate,
        ...pickBy(a => a !== '', otherFilters)
    };

    const queryVariables: QueryOrdersArgs = {
        filters: finalFilters,
        offset: 0,
        limit: LIMIT,
    };

    return (
        <>
            <Toolbar />
            <FixedBox>
                <SecondaryToolbar>
                    <Filters setFormData={setFormData} formData={formData} handleChange={handleChange}>
                        <MoreFilters formData={formData} setFormData={setFormData} />
                        <IconButton onClick={resetFilters}>
                            <RotateLeftIcon color='primary' />
                        </IconButton>
                    </Filters>
                </SecondaryToolbar>
            </FixedBox>
            <Box mx={7} my={3} alignContent='center' display='flex' alignItems='start' flexGrow={1}>
                <LoadMoreComponent query={GET_ORDERS} queryArgs={queryVariables} />
            </Box>
        </>
    );
};

export default Orders;
